import { isDefined } from '@sgme/fp';
import { useEffect, useState } from 'react';

declare global {
  interface Window {
    sgmeVersion: string;
  }
}

type Version = {
  version: string;
  buildNumber: string;
  shortSha: string;
};

export function getFrontVersion(): string {
  const result = window.sgmeVersion ?? '';
  return result;
}

function setFrontVersion(value: string) {
  window.sgmeVersion = value;
}

export function useFrontVersion(): string {
  const [version, setVersion] = useState(getFrontVersion());
  useEffect(() => {
    setFrontVersion('loading');
    fetch(`${window.location.protocol}//${window.location.host}/version.json`)
      .then(response => response.json())
      .then((data?: Version) => {
        if (isDefined(data)) {
          setFrontVersion(data.version);
          setVersion(getFrontVersion());
        }
      });
  }, []);
  return version;
}
